"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SOZLUK_UC_SAPKALARI = exports.SOZLUK_LISTE_EK_OKUYUCULARI = exports.DIGER_KUYRUGU_DONUSTURME_TABANI = exports.DIGER_KUYRUGU_TAM_OKUYUCULAR = exports.DIGER_KUYRUGU_OKUMA_SAPKALARI = exports.OLAY_SECENEK_OKUMA_SAPKALARI = exports.KATILIMCI_KARAR_OKUMA_SAPKALARI = exports.ATANABILIR_OKUMA_SAPKALARI = exports.KISI_UYGUNLUK_PANELI_GUARD_SAPKALARI = exports.KISI_UYGUNLUK_PANELI_OKUMA_SAPKALARI = exports.KISI_GOREVLENDIRME_OKUMA_SAPKALARI = exports.ZORUNLU_GOREVLENDIRME_OKUMA_SAPKALARI = exports.GECIKMIS_GOREV_OKUMA_SAPKALARI = exports.GOREV_DETAY_GUARD_SAPKALARI = exports.KENDI_GOREVLERI_SAPKALARI = void 0;
exports.uygunlukPaneliErisimi = uygunlukPaneliErisimi;
exports.uygunlukPaneliSaglikBolumuGorunurMu = uygunlukPaneliSaglikBolumuGorunurMu;
exports.sozlukListesiOkunabilirMi = sozlukListesiOkunabilirMi;
const gorev_1 = require("./gorev");
const modul_rolleri_1 = require("./modul-rolleri");
const saglik_1 = require("./saglik");
/**
 * EKRANLARIN İKİNCİL OKUMA UÇLARI — ŞAPKA LİSTELERİ (sessiz 403 paketi,
 * 29.09.2026 — madde 283; Kapsam §20.9 · §20.5).
 *
 * ════════════════════════════════════════════════════════════════════════
 * İLKE: SESSİZ 403 YASAK
 * ════════════════════════════════════════════════════════════════════════
 *
 * Menü bir ekranı bir şapkaya gösteriyorsa, o ekranın YÜKLENİRKEN çağırdığı
 * okuma uçları o şapkaya açıktır. Ekranın bir parçası o şapkaya
 * gösterilmemeliyse ekran o parçayı HİÇ ÇAĞIRMAZ ve parça çizilmez. Kullanıcı
 * *"veri yok"* ile *"görme yetkin yok"*u ayırt edemez; ekranda boş kalan parça
 * bir veri yalanıdır.
 *
 * `modul-rolleri.ts` modülün ANA okuma ucunu menüyle hizalar; bu dosya aynı
 * işi İKİNCİL uçlar için yapar. Her sabitin iki okuyucusu vardır ve ikisi de
 * AYNI sabiti okur:
 *   · ucun `@RequireRole`ü                    → kim okuyabilir
 *   · `GET kapilar`ın ilgili `…Kapisi` alanı  → ekran çağırsın mı
 *
 * ⚠️ **UÇ AÇMAK, BAHÇE DIŞI VERİYİ AÇMAK DEĞİLDİR.** Buradaki her liste bir
 * ŞAPKA listesidir; neyin görüneceğini her uçta bahçe süzgeci söyler.
 *
 * ⚠️ **BURADAKİ BİR LİSTEYİ GENİŞLETMEK ÜRÜN KARARIDIR** (§20.5). Kalıcı
 * persona yoklaması (`apps/web/e2e/sessiz-403.spec.ts`) her şapkayı menüde
 * gördüğü her satıra götürür; daraltılan liste o testi kızartır.
 */
/** İç kullanıcılar + izleyici. */
const IC_VE_IZLEYICI = [...modul_rolleri_1.IC_KULLANICI_SAPKALARI, 'viewer'];
/**
 * `GET tasks/occurrences/mine` — **KİMLİKTEN ÇÖZÜLÜR, ŞAPKA ARANMAZ.**
 * Kişinin kendine ait listesi yetki meselesi değildir: kimliği doğrulanmış
 * her iç kullanıcı YALNIZ hedefi olduğu ya da hedef kümesinde bulunduğu
 * görevleri görür. Liste yalnız temsilciyi dışarıda tutar (portal ayrı kabuk).
 */
exports.KENDI_GOREVLERI_SAPKALARI = IC_VE_IZLEYICI;
/**
 * `GET tasks/occurrences/:id` — görev detayı. Guard listesi geniştir çünkü
 * asıl kapı handler'daki YÜKLEMDİR: görev okuma şapkası + bahçe **VEYA**
 * görevin hedefinde olmak (42.1'in okuma yüzü — atanan kişi kendi görevini
 * açamazsa formuna da ulaşamaz).
 */
exports.GOREV_DETAY_GUARD_SAPKALARI = IC_VE_IZLEYICI;
/**
 * `GET tasks/overdue` — Genel bakış *"Süresi geçenler"* bloğu. Görev okuma
 * listesi + **alan sorumlusu** (ürün sahibi 29.09.2026: alan sorumlusu kendi
 * bahçesindeki gecikmiş görevleri görür). Çalışan · hekim · YSP kendi
 * gecikmiş görevlerini İşlerim'de görür; blok onlarda çağrılmaz.
 */
exports.GECIKMIS_GOREV_OKUMA_SAPKALARI = [
    ...gorev_1.GOREV_OKUMA_SAPKALARI,
    'area_supervisor',
];
/**
 * `GET workplaces/:id/zorunlu-gorevlendirmeler` — Organizasyon ve
 * Görevlendirmeler ekranlarının *zorunlu sayı* hücresi. Görevlendirme okuma
 * listesi + **lokasyon yöneticisi** (ürün sahibi 29.09.2026: lokasyon
 * yöneticisi kendi işyerinin zorunlu görevlendirmelerini ve eksiklerini
 * görür) + **İSG teknikeri** (madde 289 — ürün sahibi 29.09.2026, yetki paketi
 * artçısı: *tekniker zorunlu görevlendirmeleri görür*; önceki turda ÇAĞIRMA
 * sınıfındaydı). Bahçe süzgeci aynen. Diğer şapkalarda parça çizilmez.
 */
exports.ZORUNLU_GOREVLENDIRME_OKUMA_SAPKALARI = [
    'holding_admin',
    'company_admin',
    'isg_specialist',
    'location_manager',
    'isg_technician',
    'viewer',
];
/**
 * KİŞİ KARTININ GÖREVLENDİRME BÖLÜMÜ (madde 291 — yetki artçısı 2,
 * 30.09.2026). İki uç (`GET persons/:id/designations` ·
 * `…/designations/gate`) görevlendirme okuma listesini yayar; bayrak AYNI
 * sabitten. Kişi kartını Çalışanlar listesini gören HER iç şapka açar (tur 9 /
 * K2), ama bu bölüm görevlendirme verisidir: listede olmayan şapkada (alan
 * sorumlusu · hekim · YSP · çalışan) bölüm ÇAĞRILMAZ ve ÇİZİLMEZ. Açmak o
 * şapkaya yeni bir veri alanı açmaktır — ürün kararı.
 *
 * ✏️ MADDE 295 (yetki artçısı 3, 30.09.2026): **UYGUNLUK PANELİ BU LİSTEDEN
 * AYRILDI** — panelin kendi listesi var (`KISI_UYGUNLUK_PANELI_OKUMA_SAPKALARI`).
 * Bu liste DEĞİŞMEDİ: paneli gören alan sorumlusu · hekim · YSP görevlendirme
 * bölümünü ve listesini hâlâ görmez.
 */
exports.KISI_GOREVLENDIRME_OKUMA_SAPKALARI = modul_rolleri_1.GOREVLENDIRME_OKUMA_SAPKALARI;
/**
 * KİŞİ KARTININ UYGUNLUK PANELİ — `GET persons/:id/uygunluk` (madde 295 —
 * ürün sahibi kararı 30.09.2026; Kapsam §14 YP-4 · §20.5).
 *
 * Görevlendirme okuma listesi + **alan sorumlusu** (iş izninde kimi yazacağına
 * bu bilgiyle karar verir) + **hekim** + **YSP**; hepsi KENDİ BAHÇESİNDEKİ
 * kişilerde. **Çalışan yalnız KENDİ kartında** görür — o kol şapkadan değil
 * KİMLİKTEN çözülür (`uygunlukPaneliErisimi`); başka bir kişinin kartında
 * çalışana panel çizilmez, uç ÇAĞRILMAZ.
 *
 * ⚠️ **PANELİN İÇERİĞİ DEĞİŞMEDİ, YALNIZ GÖRÜNÜRLÜĞÜ AÇILDI.** Panel uygunluk
 * şartlarını ve geçerliliklerini taşır; tanı · bulgu · gerekçe taşımaz. Sağlık
 * bölümü yanıtın İÇİNDE ikinci bir kapıdır (`uygunlukPaneliSaglikBolumuGorunurMu`
 * — aşağıda): `SAGLIK_OKUMA_SAPKALARI` (§16.11/10) **VEYA kişinin KENDİ kartı**
 * (✏️ ürün sahibi 30.09.2026 — YP-5). Alan sorumlusu ve izleyici BAŞKASININ
 * kartında bölümü görmez (`null` iner, çizilmez); şapka listesi GENİŞLEMEDİ.
 *
 * ⚠️ **GÖREVLENDİRME LİSTESİ AÇILMADI** (`GOREVLENDIRME_OKUMA_SAPKALARI`
 * aynen): panel ayrı uçtur, ayrı listedir.
 */
exports.KISI_UYGUNLUK_PANELI_OKUMA_SAPKALARI = [
    ...modul_rolleri_1.GOREVLENDIRME_OKUMA_SAPKALARI,
    'area_supervisor',
    'physician',
    'ysp',
];
/**
 * Panel ucunun GUARD listesi — geniştir çünkü asıl kapı handler'daki
 * YÜKLEMDİR (`uygunlukPaneliErisimi`): şapka + bahçe **VEYA** kendi kartı.
 * `tasks/occurrences/:id` ile aynı desen. Temsilci dışarıda (portal ayrı kabuk).
 */
exports.KISI_UYGUNLUK_PANELI_GUARD_SAPKALARI = IC_VE_IZLEYICI;
function uygunlukPaneliErisimi(sapkalar, kendiKartiMi) {
    if (kendiKartiMi)
        return 'kendi';
    return sapkalar.some((sapka) => exports.KISI_UYGUNLUK_PANELI_OKUMA_SAPKALARI.includes(sapka))
        ? 'sapka'
        : 'yok';
}
/**
 * **PANELİN SAĞLIK BÖLÜMÜ — İKİNCİ KAPININ TEK YÜKLEMİ** (YP-5 — ürün sahibi
 * kararı 30.09.2026; Kapsam §14 · §16.11/10 ✏️).
 *
 * | Kim | Sağlık bölümü |
 * | --- | --- |
 * | sağlık okuma şapkası, bahçesindeki kişide | görür (değişmedi) |
 * | alan sorumlusu, başkasının kartında | **görmez** — sınır korunur; sağlık kısıtı iş izni kapısında zaten otomatik uygulanır (KVKK: en az bilgi) |
 * | **kişi, KENDİ kartında** | **görür** — kendi uygunluk durumu kendi verisidir |
 * | çalışan, başkasının kartında | panel hiç çizilmez, uç çağrılmaz (`uygunlukPaneliErisimi` → `yok`) |
 *
 * ⚠️ **ŞAPKA LİSTESİ GENİŞLEMEDİ — kol KİMLİKTEN çözülür** (`health-opinions/
 * kendi` ucunun "kendi kaydı" ekseni; §16.11/10 dar açılışı). Bölümün İÇERİĞİ
 * de değişmedi: şart satırı + durumu + geçerlilik bitişi. Tanı · bulgu ·
 * gerekçe · karar metni · kısıt listesi bu bölümde YOKTUR (kanaatin kendisi
 * hâlâ yalnız sağlık okuma listesine açıktır).
 */
function uygunlukPaneliSaglikBolumuGorunurMu(sapkalar, kendiKartiMi) {
    if (kendiKartiMi)
        return true;
    return sapkalar.some((sapka) => saglik_1.SAGLIK_OKUMA_SAPKALARI.includes(sapka));
}
/**
 * `GET actions/assignable-users` — atanabilir havuz. Atama yapabilen şapkalar;
 * izleyici atama yapamaz, ekran ona bu parçayı çizmez.
 */
exports.ATANABILIR_OKUMA_SAPKALARI = [
    'holding_admin',
    'company_admin',
    'location_manager',
    'isg_specialist',
    'isg_technician',
];
/**
 * `GET ptw/participant-decisions/pending` — İşlerim'in katılımcı kararı kolu.
 * Karar verebilen iç kullanıcılar; izleyici karar veremez, kabuk onun için
 * bu çağrıyı yapmaz.
 */
exports.KATILIMCI_KARAR_OKUMA_SAPKALARI = modul_rolleri_1.IC_KULLANICI_SAPKALARI;
/**
 * `GET incidents/options` — seçenek listesi REFERANS verisidir; izleyici de
 * okur (Olaylar · Sözlükler ekranları). Temsilci dar yanıt alır (U9).
 */
exports.OLAY_SECENEK_OKUMA_SAPKALARI = [
    ...modul_rolleri_1.IC_KULLANICI_SAPKALARI,
    'viewer',
    'contractor_rep',
];
/**
 * `GET incidents/diger-kuyrugu` — guard listesi. Asıl kapı handler'da
 * kaynak başınadır (tenant liste anahtarları); `DIGER_KUYRUGU_TAM_OKUYUCULAR`
 * iki kaynağı da okur.
 */
exports.DIGER_KUYRUGU_OKUMA_SAPKALARI = IC_VE_IZLEYICI;
/**
 * *"Diğer"* kuyruğunu tenant liste anahtarından BAĞIMSIZ okuyanlar: sözlüğü
 * tanımlayan holding yöneticisi kuyruğu görmelidir; izleyici salt okur.
 * ⚠️ Bu liste yalnız OKUMAYI söyler — kalıcı kaleme dönüştürme kapısı ayrı
 * yüklemdir (`DIGER_KUYRUGU_DONUSTURME_TABANI` + hedef sözlüğün tenant
 * listesi; satırın `kalemKapisi` onu taşır).
 */
exports.DIGER_KUYRUGU_TAM_OKUYUCULAR = ['holding_admin', 'viewer'];
/**
 * *"Diğer"* metnini sözlük kalemine DÖNÜŞTÜRMENİN TABANI (yetki paketi
 * artçısı, 29.09.2026 — ürün sahibi kararı; Kapsam §20.5).
 *
 * **TABAN KODDA, LİSTEDEN BAĞIMSIZ VE ÇIKARILAMAZ:** holding yöneticisi hedef
 * sözlüğün tenant listesinde olmasa da dönüştürür. Tenant listesi yalnız
 * müşterinin EKLEDİĞİ şapkaları tutar; kapı = taban ∪ liste. PTW geri çekme
 * yetkisindeki *"taban izin veren"* deseninin aynısıdır (`@isg/db
 * ptwGeriCekmeYetkisiVarMi`) — yeni bir yetki mekanizması DEĞİLDİR.
 *
 * ⚠️ **TABAN TENANT AYARINA YAZILMAZ** — yazılsaydı müşteri onu listeden
 * çıkarabilirdi. ⚠️ İzleyici okur, dönüştüremez (guard yazma ucunda 403'ler;
 * satır kapısı da kapalıdır).
 */
exports.DIGER_KUYRUGU_DONUSTURME_TABANI = ['holding_admin'];
/**
 * SÖZLÜK LİSTESİ EK OKUYUCULARI — **BLANKET AÇMA YOK.** Bir sözlük listesi,
 * onu kullanan ekranı menüde gören şapkalara açılır; listede olmayan sözlük
 * yalnız `SOZLUK_OKUMA_SAPKALARI`na açıktır.
 *
 * ⚠️ Hassas bağlamlı listeler (sağlık kısıtı · muayene türü…) buraya
 * eklenmeden önce ürün kararı ister.
 */
exports.SOZLUK_LISTE_EK_OKUYUCULARI = {
    // İş ekipmanları ekranının tip süzgeci ve ekleme satırı.
    equipment_tip: modul_rolleri_1.EKIPMAN_OKUMA_SAPKALARI,
    // Aksiyonlar ekranının kaynak süzgeci.
    aksiyon_kaynagi: modul_rolleri_1.AKSIYON_OKUMA_SAPKALARI,
    // Çalışanlar > KKD zimmetleri sekmesinin kalem süzgeci (madde 287 — persona
    // yoklaması sekmelere genişleyince ölçüldü). Zimmet listesini okuyan şapka
    // kalem adlarını satırlarda ZATEN görür; açılan yeni bir veri alanı değildir.
    kkd_kalemi: modul_rolleri_1.KKD_ZIMMET_OKUMA_SAPKALARI,
    // Çalışanlar > Görevlendirmeler sekmesinin tür süzgeci (madde 292 — ürün
    // sahibi 30.09.2026: *görevlendirme tür sözlüğü de açılır*). Görevlendirme
    // listesini okuyan şapka tür adlarını satırlarda ZATEN görür.
    gorevlendirme_turu: modul_rolleri_1.GOREVLENDIRME_OKUMA_SAPKALARI,
};
/** `GET lookup/:listeKodu` guard listesi — sözlük okuyucuları ∪ ek okuyucular. */
exports.SOZLUK_UC_SAPKALARI = [
    ...new Set([
        ...modul_rolleri_1.SOZLUK_OKUMA_SAPKALARI,
        ...Object.values(exports.SOZLUK_LISTE_EK_OKUYUCULARI).flat(),
    ]),
];
/** Bu şapka bu sözlük listesini okuyabilir mi — ucun ve ekranın TEK yüklemi. */
function sozlukListesiOkunabilirMi(sapka, listeKodu) {
    if (sapka === 'contractor_rep')
        return listeKodu === 'evrak_tipi';
    if (modul_rolleri_1.SOZLUK_OKUMA_SAPKALARI.includes(sapka))
        return true;
    return exports.SOZLUK_LISTE_EK_OKUYUCULARI[listeKodu]?.includes(sapka) ?? false;
}
//# sourceMappingURL=ikincil-okuma.js.map